import { createAction, createReducer } from "@reduxjs/toolkit";

// Actions
export const addToCart = createAction("cart/addToCart");
export const removeFromCart = createAction("cart/removeFromCart");
export const updateCart = createAction("cart/updateCart");
export const deleteCart = createAction("cart/deleteCart");
export const clearCart = createAction("cart/clearCart");
export const setCart = createAction("cart/setCart");

// Initial state
const initialState = {
  cart: [],
};

export const cartReducer = createReducer(initialState, {
  [addToCart]: (state, action) => {
    state.cart.push(action.payload);
  },

  [removeFromCart]: (state, action) => {
    state.cart = state.cart.filter((item, i) => i !== action.payload);
  },

  [updateCart]: (state, action) => {
    const { index, product } = action.payload;
    state.cart[index] = product;
  },

  [deleteCart]: (state, action) => {
    state.cart = state.cart.filter((item, i) => i !== action.payload);
  },

  [clearCart]: (state) => {
    state.cart = [];
  },

  [setCart]: (state, action) => {
    state.cart = action.payload;
  }
});
